import { defineComponent as _defineComponent } from 'vue'
import { AppButton } from '@shared/ui'


export default /*#__PURE__*/_defineComponent({
  __name: 'PayBlocked',
  emits: ['closeModal'],
  setup(__props, { emit }) {



return { __sfc: true,emit, AppButton }
}

})